import moment from "moment";
import { formatRelative, subDays } from "date-fns";


export function getTimeAgo(timestamp) {
    return formatRelative(timestamp.seconds * 1000, new Date());
}

function rand(min, max) {
    return min + Math.random() * (max - min);
}

let lastHue = Math.floor(Math.random() * 360);

export function getRandomColor(light = false, dark = false) {
    var h = (lastHue + 50) % 360 + rand(10, 30); //to make the hues different each time
    lastHue = h;
    var s = rand(60, 80) + (light ? 20 : 0) + (dark ? -20 : 0);
    var l = rand(60, 80) + (light ? 20 : 0) + (dark ? -20 : 0);
    return 'hsl(' + h + ',' + s + '%,' + l + '%)';
}

export function darkenHSL(hslColor, percent) {
    // Extract the H, S, and L values from the HSL string
    const hslRegex = /hsl\(\s*([\d.]+)\s*,\s*([\d.]+)%\s*,\s*([\d.]+)%\s*\)/;
    const match = hslColor.match(hslRegex);

    if (!match) {
        throw new Error('Invalid HSL color format');
    }

    let [, h, s, l] = match;
    h = parseInt(h, 10);
    s = parseInt(s, 10);
    l = parseInt(l, 10);

    // Calculate the new lightness value
    l = Math.max(0, Math.min(100, l - percent));

    // Return the new HSL color string
    return `hsl(${h}, ${s}%, ${l}%)`;
}

export function isMobile() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const isUserAgentMobile = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase());
    const isScreenWidthMobile = window.innerWidth <= 768;

    return isUserAgentMobile || isScreenWidthMobile;
}

export function parseDuration(str) {
    let duration = moment.duration(str);
    let h = duration._data.hours;
    let m = duration._data.minutes;
    let s = duration._data.seconds;

    let res = "";

    if (h) {
        if (h > 9) {
            res += h + ":";
        } else {
            res += '0' + h + ":";
        }
    }

    if (m > 9) {
        res += m + ":";
    } else {
        res += '0' + m + ":";
    }

    if (s > 9) {
        res += s;
    } else {
        res += '0' + s;
    }

    return res;
}

function isRTLChar(char) {
    const codePoint = char.codePointAt(0);

    // Define RTL Unicode ranges
    const rtlRanges = [
        [0x0600, 0x06FF], // Arabic
        [0x0750, 0x077F], // Arabic Supplement
        [0x08A0, 0x08FF], // Arabic Extended-A
        [0x0590, 0x05FF], // Hebrew
        [0xFB1D, 0xFB4F], // Hebrew Extended
        [0x0700, 0x074F], // Syriac
        [0x0780, 0x07BF], // Thaana
        [0x07C0, 0x07FF], // N'Ko
        [0x0800, 0x083F], // Samaritan
        [0x0840, 0x085F], // Mandaic
        [0x0860, 0x086F], // Syriac Supplement
        [0xFB50, 0xFDFF], // Arabic Presentation Forms-A
        [0xFE70, 0xFEFF], // Arabic Presentation Forms-B
        [0x10800, 0x1083F], // Cypriot Syllabary
        [0x1E800, 0x1E8DF], // Mende Kikakui
        [0x1EE00, 0x1EEFF], // Arabic Mathematical Alphabetic Symbols
    ];

    return rtlRanges.some(([start, end]) => codePoint >= start && codePoint <= end);
}

export function containsRTLChars(str) {
    // Check the first 5 characters of the string
    const firstFiveChars = str.slice(0, 5);
    for (let char of firstFiveChars) {
        if (isRTLChar(char)) {
            return true;
        }
    }
    return false;
}